// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import asyncMergeSort from 'async-merge-sort'

import {
  castToFloat,
  castToString,
  ifObjectGetValue,
} from 'helpers/reduxFormFunctions'

export const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    let av
    let bv

    switch (col) {
      case 'company' :
        av = ifObjectGetValue(a[col], 'companyCode').toLowerCase()
        bv = ifObjectGetValue(b[col], 'companyCode').toLowerCase()
        break

      case 'distance' :
        av = castToFloat(a[col])
        bv = castToFloat(b[col])
        break

      default :
        av = castToString(a[col]).toLowerCase()
        bv = castToString(b[col]).toLowerCase()
        break
    }

    return (
      asc
        ? cb(null, (av >= bv) ? 1 : -1)
        : cb(null, (av <= bv) ? 1 : -1)
    )
  }

  return asyncMergeSort(arr, sorter, callback)
}

// based on form's values (v), determine which column to sort by.
export const getSortColByFormValues = v => {
  let col
  if (v.siteName) {
    col = 'siteName'
  } else if (v.asr) {
    col = 'asr'
  } else if (v.callSign) {
    col = 'callSign'
  }
  return col
}
